/**
 * Parse endpoint to extract path and query parameters
 * Example: /customers/{customer_id}/charges?status={status}&limit={limit}
 * Returns: {
 *   pathParams: ['customer_id'],
 *   queryParams: ['status', 'limit']
 * }
 */

export interface ParsedEndpoint {
  pathParams: string[];
  queryParams: string[];
  cleanPath: string; // Path without query string
}

export const parseEndpoint = (endpoint: string): ParsedEndpoint => {
  // Split endpoint into path and query parts
  const [pathPart, queryPart] = endpoint.split('?');

  // Extract path parameters
  const pathRegex = /\{([^}]+)\}/g;
  const pathParams: string[] = [];
  let match;

  while ((match = pathRegex.exec(pathPart)) !== null) {
    pathParams.push(match[1]);
  }

  // Extract query parameters
  const queryParams: string[] = [];
  if (queryPart) {
    const queryRegex = /\{([^}]+)\}/g;
    while ((match = queryRegex.exec(queryPart)) !== null) {
      queryParams.push(match[1]);
    }
  }

  return {
    pathParams,
    queryParams,
    cleanPath: pathPart,
  };
};

/**
 * Example usage:
 *
 * parseEndpoint('/customers/{customer_id}')
 * // { pathParams: ['customer_id'], queryParams: [], cleanPath: '/customers/{customer_id}' }
 *
 * parseEndpoint('/customers/{customer_id}/charges?status={status}&limit={limit}')
 * // { pathParams: ['customer_id'], queryParams: ['status', 'limit'], cleanPath: '/customers/{customer_id}/charges' }
 *
 * parseEndpoint('/users?email={email}&role={role}')
 * // { pathParams: [], queryParams: ['email', 'role'], cleanPath: '/users' }
 */
